import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const t = l((o, r) => /* @__PURE__ */ e.jsx(
  s,
  {
    ref: r,
    ...o,
    image: (i) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...i,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M7 2H5V0h6v2H9v1.076A6.502 6.502 0 0 1 8 16 6.5 6.5 0 0 1 7 3.076zm0 4v3.5a1 1 0 0 0 .293.707l2 2 1.414-1.414L9 9.086V6z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
t.displayName = "TimerIcon";
export {
  t as TimerIcon,
  t as default
};
//# sourceMappingURL=index.js.map
